
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface SiteStats {
  total_reviews: number;
  total_airports: number;
  total_users: number;
  average_film_friendly_score: number;
}

interface SiteStatsGridProps {
  stats: SiteStats;
}

export default function SiteStatsGrid({ stats }: SiteStatsGridProps) {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <Card>
        <CardHeader>
          <CardTitle>Total Reviews</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-3xl font-bold">{stats.total_reviews}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Total Airports</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-3xl font-bold">{stats.total_airports}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Total Users</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-3xl font-bold">{stats.total_users}</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Avg Film Score</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-3xl font-bold">{stats.average_film_friendly_score}</p>
        </CardContent>
      </Card>
    </div>
  );
}
